// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__ikT+f","placeHolderShimmer":"Report_placeHolderShimmer__UXMrr"};